import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary border-t border-border">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_7fda3ca4-b48d-456b-874c-970d135d0da5/artifacts/8dibz6we_VCC%20Logo%20-%20Horizontal.png" 
                alt="V Cosmetic Crafters"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Innovation-led cosmetic R&D and formulation development partner for ambitious beauty brands.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-brand-teal">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/rd-capabilities" className="text-sm text-muted-foreground hover:text-brand-teal">
                  R&D Capabilities
                </Link>
              </li>
              <li>
                <Link to="/innovation" className="text-sm text-muted-foreground hover:text-brand-teal">
                  Innovation Areas
                </Link>
              </li>
              <li>
                <Link to="/process" className="text-sm text-muted-foreground hover:text-brand-teal">
                  Our Process
                </Link>
              </li>
              <li>
                <Link to="/why-us" className="text-sm text-muted-foreground hover:text-brand-teal">
                  Why Choose Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              <li className="text-sm text-muted-foreground">Custom Formulation</li>
              <li className="text-sm text-muted-foreground">Stability Testing</li>
              <li className="text-sm text-muted-foreground">Regulatory Support</li>
              <li className="text-sm text-muted-foreground">Private Label Development</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-brand-teal mt-1 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">+91 812 171 2626</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-brand-teal mt-1 flex-shrink-0" />
                <a href="mailto:info@vcosmeticcrafters.com" className="text-sm text-muted-foreground hover:text-brand-teal">
                  info@vcosmeticcrafters.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-brand-teal mt-1 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">
                  Hyderabad, Telangana, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} V Cosmetic Crafters Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-brand-teal">
                Privacy Policy
              </Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-brand-teal">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Brand Color Accent Bar */}
      <div className="h-1 flex">
        <div className="flex-1 bg-brand-teal"></div>
        <div className="flex-1 bg-brand-red"></div>
      </div>
    </footer>
  );
};

export default Footer;
